import { IAutocompleteItem } from 'shared/components/molecules';

export class EnumHelper {
  public static getValue(enumObj: object, key: number | string): string {
    return enumObj[key as keyof typeof enumObj] as string;
  }

  public static getKey(enumObj: object, value: number | string): number | string {
    const a = EnumHelper.toKVPArray(enumObj);
    const valRecord = a.find((e) => e['value'] == value);
    return valRecord ? valRecord['value'] : typeof value === 'string' ? '' : 0;
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public static toKeyArray(enumObj: object): any {
    return Object.keys(enumObj);
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public static toValueArray(enumObj: object, includeNone = false): any {
    return Object.values(enumObj).filter((e) => includeNone || (e as string) !== 'None');
  }

  public static toAutoCompleteOptions<T>(enumObj: object, includeNone = false): IAutocompleteItem<T>[] {
    const result = Object.entries(enumObj)
      .filter((e) => includeNone || (e[1] as string) !== 'None')
      .map((e) => {
        const key = this.parseValue(e[1] as never, false) as string;
        return {
          label: key as string,
          value: key as T,
        } as IAutocompleteItem<T>;
      });
    return result;
  }

  private static toKVPArray(
    enumObj: object,
    key?: string,
    value?: string | number,
    normalizeKey = false,
    normalizeValue = false,
  ): Record<string, string | number>[] {
    if (!key) key = 'key';
    if (!value) value = 'value';
    const result = Object.entries(enumObj).map((e) => {
      return {
        [key as string]: this.parseValue(e[1] as never, normalizeKey) as string,
        [value as string | number]: this.parseValue(e[0] as never, normalizeValue),
      } as Record<string, string | number>;
    });
    return result;
  }

  private static parseValue(value: never, normalizeString: boolean): string | number {
    if (this.isNumeric(value)) {
      return parseFloat(value);
    } else if (normalizeString) {
      return this.formatString(value);
    } else {
      return value;
    }
  }

  private static formatString(str: string): string {
    const stringWithSpaces = str.replace(/_/g, ' ');
    return stringWithSpaces.charAt(0).toUpperCase() + stringWithSpaces.slice(1).toLowerCase();
  }

  private static isNumeric(str: unknown): boolean {
    if (typeof str !== 'string') return false;
    return !isNaN(str as never) && !isNaN(parseFloat(str));
    }

  public static toCamelCase(str: string): string {
        return str.charAt(0).toLowerCase() + str.slice(1);
    }
}
